import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
} from '@angular/core';

@Directive({
  selector: '[appScrollIntoView]',
})
export class ScrollIntoViewDirective implements OnChanges {
  @Input() appScrollIntoView: boolean | undefined;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private elementRef: ElementRef,
  ) {}

  ngOnChanges(): void {
    if (isPlatformBrowser(this.platformId) &&
      coerceBooleanProperty(this.appScrollIntoView)) {
      requestAnimationFrame(() => { // Double RAF for extra safety
        (this.elementRef.nativeElement as HTMLElement).scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    }
  }
}
